import React, { createContext, useEffect, useContext, useState, useCallback } from 'react';
import { useCreateSubscriptionContext } from './createSubscriptionContext';

export const COMPLEX_EMAIL_CONTEXT_KEYS = {
  FROM_ADDRESS: 'FROM_ADDRESS',
  EMAIL_SUBJECT: 'EMAIL_SUBJECT',
  ATTACHMENTS: 'ATTACHMENTS',
  OPEN_SUBJECT_MODAL: 'OPEN_SUBJECT_MODAL',
  IS_MOBILE_VIEW: 'IS_MOBILE_VIEW',
  EMAIL_CONFIGURED: 'EMAIL_CONFIGURED',
}

const INITIAL_STATE = () => ({
  [COMPLEX_EMAIL_CONTEXT_KEYS.OPEN_SUBJECT_MODAL] : false,
  [COMPLEX_EMAIL_CONTEXT_KEYS.EMAIL_SUBJECT]: null,
  [COMPLEX_EMAIL_CONTEXT_KEYS.ATTACHMENTS]: [],
  [COMPLEX_EMAIL_CONTEXT_KEYS.FROM_ADDRESS]: null,
  [COMPLEX_EMAIL_CONTEXT_KEYS.IS_MOBILE_VIEW]: false,
  [COMPLEX_EMAIL_CONTEXT_KEYS.EMAIL_CONFIGURED]: null,
});

const defaultSubject = {
  blockType: 'text',
  contents: [
     {
       contentType: 'PARAGRAPH',
       style: {
         lineSpacing: 1.5,
         fontWeight: [],
         color: '#000000'
       },
       content: ''
     },
     {
       contentType: "LINE_BREAK",
       content: "\n",
       style: {
         lineSpacing: 1.5,
         color: "#000000"
       }
     }
    ],
  style: {}
};

const DEFAULT_CONTEXT = (existingDocument = undefined, openSubjectModal = true) => ({
  [COMPLEX_EMAIL_CONTEXT_KEYS.FROM_ADDRESS]: existingDocument?.fromAddressId ?? null,
  [COMPLEX_EMAIL_CONTEXT_KEYS.EMAIL_SUBJECT]: existingDocument?.subject || defaultSubject,
  [COMPLEX_EMAIL_CONTEXT_KEYS.ATTACHMENTS]: existingDocument?.attachments?.map(attachment => ({
    attachmentId: attachment.attachmentId,
    contentType: attachment.contentType,
    documentName: attachment.documentName,
    thumbnail: attachment.thumbnail,
    passwordProtected: attachment.passwordProtected || false,
    documentId: attachment.documentId
  })),
  [COMPLEX_EMAIL_CONTEXT_KEYS.OPEN_SUBJECT_MODAL] : openSubjectModal ? existingDocument?.subject === undefined : false,
  ...Object.assign({}, existingDocument?.attachments?.reduce((acc, attachment) => {
      return { ...acc, [attachment.attachmentId]: attachment };
     }, {}))
});

const ComplexEmailContext = createContext(null);

export const useEmailContext = (selector, customName = '', debug = false) => {
  const store = useContext(ComplexEmailContext);
    if (!store) {
    throw new Error('Store not found');
  }

  const [ state, setState ] = useState(selector(store.get()));

  useEffect(() => {
    return store.subscribe(() => {
      setState(previousState => {
        if (debug) {
          console.log("Change in context :: ", customName, selector(store.get()), previousState, previousState === selector(store.get()));
        }
        return selector(store.get(), previousState);
      });
    }, debug ? customName : '');
  }, []);

  useEffect(() => {
    if (debug) console.log("context change reflected in state :: ",customName, state, store.get())
  }, [state, debug, customName]);

  return [state, store];
}

const Provider = ({ children, customState = {} }) => {
  const store = useCreateSubscriptionContext(Object.assign({}, INITIAL_STATE(), customState));

  store.setInitialState = useCallback((existingDocument = undefined, openSubjectModal = true) => {
    store.set(DEFAULT_CONTEXT(existingDocument, openSubjectModal));
  }, []);

    return (
    <ComplexEmailContext.Provider value={store}>
      {children}
    </ComplexEmailContext.Provider>
  );
}

export default Provider;